import React from 'react'

function Details() {
  return (
    <div>
      <h2 className="text-center " style={{ color: "#513aa3ff" }}>Hello from About Page</h2>
      <div style={{ fontSize: "18px", fontWeight: "bold",margin:"50px" }}>
        <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Ad assumenda deleniti alias veritatis nostrum? Vel sapiente harum odio excepturi recusandae. Lorem ipsum, dolor sit amet consectetur adipisicing elit. Repudiandae voluptate quod ab eos doloremque eligendi non beatae laboriosam expedita fugiat. </p>
        <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Ad assumenda deleniti alias veritatis nostrum? Vel sapiente harum odio excepturi recusandae. Lorem ipsum, dolor sit amet consectetur adipisicing elit. Repudiandae voluptate quod ab eos doloremque eligendi non beatae laboriosam expedita fugiat. </p>
        <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Ad assumenda deleniti alias veritatis nostrum? Vel sapiente harum odio excepturi recusandae. Lorem ipsum, dolor sit amet consectetur adipisicing elit. Repudiandae voluptate quod ab eos doloremque eligendi non beatae laboriosam expedita fugiat. </p>
      </div>
    </div>
  )
}

export default Details